import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { unregisterServiceWorkersInDev } from "./pwa/serviceWorkerDevCleanup";

void unregisterServiceWorkersInDev().finally(() => {
  const el = document.getElementById("root");
  if (!el) {
    throw new Error("Root element not found");
  }
  createRoot(el).render(<App />);
});
